import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LifeBuoy, Lock, Loader2 } from "lucide-react";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@gsupport.online");
  const [password, setPassword] = useState("gsupport2026");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <main data-testid="admin-login-page" className="min-h-[80vh] grid place-items-center px-4 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2.5 mb-8">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#1A73E8] text-white">
            <LifeBuoy className="w-5 h-5" />
          </span>
          <span className="font-heading font-bold text-xl tracking-tight text-slate-900">Gsupport Admin</span>
        </Link>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl shadow-slate-900/5 p-8">
          <div className="flex items-center gap-2 text-slate-900 mb-1">
            <Lock className="w-5 h-5 text-[#1A73E8]" />
            <h1 className="font-heading text-xl font-semibold">Sign in to manage content</h1>
          </div>
          <p className="text-sm text-slate-500 mb-6">Private area — only the site owner can edit articles.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Email</label>
              <input
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-11 px-4 rounded-lg border border-slate-200 outline-none focus:border-[#1A73E8] focus:ring-4 focus:ring-blue-100 transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Password</label>
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-11 px-4 rounded-lg border border-slate-200 outline-none focus:border-[#1A73E8] focus:ring-4 focus:ring-blue-100 transition-all"
              />
            </div>

            {error && (
              <p data-testid="admin-login-error" className="text-sm text-[#D93025] bg-red-50 rounded-lg px-3 py-2">{error}</p>
            )}

            <button
              data-testid="admin-login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-lg bg-[#1A73E8] hover:bg-[#174EA6] text-white font-semibold transition-colors inline-flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
            </button>
          </form>

          <div className="mt-6 text-xs text-slate-500 bg-slate-50 rounded-lg px-4 py-3">
            <span className="font-semibold">Demo credentials:</span> admin@gsupport.online / gsupport2026
          </div>
        </div>

        <Link to="/" className="block text-center text-sm text-slate-500 hover:text-[#1A73E8] mt-6">← Back to Help Center</Link>
      </div>
    </main>
  );
}
